<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ team.id ? "Editar" : "Nova" }} Equipe
              </div>
            </div>
            <hr style="margin-top: -4px">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> Nome:
                      </label>
                      <input
                        id="Name"
                        v-model="team.name"
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        placeholder=""
                      >
                    </div>
                    <div class="form-group col-md-6">
                      <label for="Name"> Veículo: </label>
                      <v-select
                        v-model="team.vehicle_id"
                        :options="vehicles"
                        :reduce="(vehicles) => vehicles.id"
                        :label="'name'"
                        class="vselect"
                      />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name"> Tipo de Equipe: </label>
                      <v-select
                        v-model="team.type_id"
                        :options="teamTypes"
                        :reduce="(teamTypes) => teamTypes.id"
                        :label="'name'"
                        class="vselect"
                      />
                      <small class="text-muted">
                        Define se a equipe é considerada disponível ao solicitar
                        viatura por tipo, nas decisões técnicas.
                      </small>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="frotasCode"> Código identificador: </label>
                      <input
                        id="frotasCode"
                        v-model="team.frotas_identifier_code"
                        type="text"
                        class="form-control"
                        maxlength="30"
                        placeholder="Ex: SAMU-BNU-01"
                      >
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Status:
                      </label>
                      <select
                        v-model="team.status"
                        class="form-control"
                      >
                        <option :value="1">
                          Ativo
                        </option>
                        <option :value="0">
                          Inativo
                        </option>
                      </select>
                    </div>
                  </div>

                  <div
                    v-if="team.id"
                    class="row"
                  >
                    <div class="col-md-12">
                      <hr>
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="mb-0">
                          Equipamentos desta equipe
                        </h6>
                        <button
                          type="button"
                          class="btn btn-sm btn-success"
                          @click="abrirAlocacao"
                        >
                          Adicionar equipamento
                        </button>
                      </div>

                      <p
                        v-if="equipamentos.length === 0"
                        class="text-muted"
                        style="font-size: 13px"
                      >
                        Nenhum equipamento alocado para esta equipe.
                      </p>

                      <table
                        v-else
                        class="table table-sm"
                      >
                        <thead>
                          <tr>
                            <th>Equipamento</th>
                            <th>Série</th>
                            <th class="text-right">
                              Quantidade
                            </th>
                            <th>Desde</th>
                            <th class="text-right">
                              Ações
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="a in equipamentos"
                            :key="a.id"
                          >
                            <td>
                              {{ a.equipment ? a.equipment.name : "—" }}
                              <small
                                v-if="a.equipment && a.equipment.measure_value"
                                class="text-muted"
                              >
                                · {{ a.equipment.measure_value }}
                                {{ a.equipment.type && a.equipment.type.unit ? a.equipment.type.unit.abbreviation : "" }}
                              </small>
                            </td>
                            <td>
                              <span
                                v-if="a.equipment && a.equipment.serial"
                                class="badge badge-secondary text-monospace"
                              >{{ a.equipment.serial }}</span>
                              <span
                                v-else
                                class="text-muted"
                              >—</span>
                            </td>
                            <td class="text-right">
                              {{ a.quantity }}
                            </td>
                            <td>{{ dataHora(a.allocated_at) }}</td>
                            <td class="text-right">
                              <template v-if="devolvendoId === a.id">
                                <div class="d-inline-flex align-items-center" style="gap: 6px">
                                  <input
                                    v-model.number="devolucaoQtd"
                                    type="number"
                                    class="form-control form-control-sm text-right"
                                    style="width: 72px"
                                    min="1"
                                    :max="a.quantity"
                                  >
                                  <button
                                    type="button"
                                    class="btn btn-sm btn-outline-secondary"
                                    :disabled="devolvendo"
                                    @click="devolvendoId = null"
                                  >
                                    Cancelar
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-sm btn-danger"
                                    :disabled="devolvendo || !devolucaoValida(a)"
                                    @click="confirmarDevolucao(a)"
                                  >
                                    {{ devolvendo ? "..." : "Confirmar" }}
                                  </button>
                                </div>
                              </template>
                              <button
                                v-else
                                type="button"
                                class="btn btn-sm btn-outline-danger"
                                @click="abrirDevolucao(a)"
                              >
                                Devolver
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>Campos obrigatórios</strong>
                  </span>
                  <div class="block text-right">
                    <router-link
                      to="/teams"
                      class="btn btn-back mr-1"
                    >
                      <i class="fa fa-arrow-left" /> Voltar
                    </router-link>
                    <a
                      v-if="$hasAbility('equipe.gerenciar')"
                      class="btn btn-add"
                      @click="save"
                    >
                      Salvar
                      <i class="fa fa-save" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-model="mostrarAlocacao"
      title="Adicionar equipamento à equipe"
      hide-footer
    >
      <div class="form-group">
        <label>Equipamento</label>
        <v-select
          v-model="novaAlocacao.equipment_id"
          :options="disponiveis"
          :reduce="(e) => e.id"
          label="rotulo"
          placeholder="Somente os que têm saldo disponível"
        />
      </div>
      <div class="form-group">
        <label>Quantidade</label>
        <input
          v-model.number="novaAlocacao.quantity"
          type="number"
          min="1"
          :max="maxDisponivel"
          class="form-control"
        >
        <small
          v-if="maxDisponivel"
          class="text-muted"
        >
          Disponível: {{ maxDisponivel }}
        </small>
      </div>
      <div class="text-right">
        <button
          type="button"
          class="btn btn-secondary mr-1"
          @click="mostrarAlocacao = false"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="btn btn-primary"
          :disabled="alocando"
          @click="alocar"
        >
          {{ alocando ? "Alocando..." : "Alocar" }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import Loading from 'vue-loading-overlay'
import BaseCrud from '../../layouts/Base/BaseCrud'

export default {
  components: {
    BaseCrud,
    vSelect,
    Loading,
  },
  data() {
    return {
      equipamentos: [],
      disponiveis: [],
      devolvendo: false,
      devolvendoId: null,
      devolucaoQtd: 1,
      alocando: false,
      mostrarAlocacao: false,
      novaAlocacao: { equipment_id: null, quantity: 1 },
      team: {
        name: '',
        vehicle_id: null,
        type_id: null,
        frotas_identifier_code: null,
        status: '1',
      },
      vehicles: [],
      teamTypes: [],
    }
  },
  computed: {
    maxDisponivel() {
      const e = this.disponiveis.find(x => x.id === this.novaAlocacao.equipment_id)
      return e ? e.disponivel : null
    },
  },
  mounted() {
    const self = this

    self.getVehicles()
    self.getTeamTypes()

    const { id } = self.$route.params
    if (id) {
      self.getTeam(id)
    }
  },
  methods: {
    carregarEquipamentos() {
      const self = this
      if (!self.team.id) return

      axios
        .get(`${self.$store.state.api}teams/${self.team.id}/equipment`)
        .then(r => {
          self.equipamentos = r.data.data || []
        })
        .catch(() => {
          self.equipamentos = []
        })
    },

    abrirAlocacao() {
      const self = this
      self.novaAlocacao = { equipment_id: null, quantity: 1 }

      axios
        .get(`${self.$store.state.api}equipment`)
        .then(r => {
          self.disponiveis = (r.data.data || [])
            .filter(e => e.disponivel > 0)
            .map(e => ({
              ...e,
              rotulo: `${e.name}${e.serial ? ` · ${e.serial}` : ''} (${e.disponivel} disponível)`,
            }))
          self.mostrarAlocacao = true
        })
        .catch(() => {
          self.$message('Erro', 'Não foi possível carregar os equipamentos disponíveis.', 'error')
        })
    },

    alocar() {
      const self = this
      self.alocando = true

      axios
        .post(`${self.$store.state.api}equipment/${self.novaAlocacao.equipment_id}/allocate`, {
          team_id: self.team.id,
          quantity: self.novaAlocacao.quantity,
        })
        .then(() => {
          self.mostrarAlocacao = false
          self.carregarEquipamentos()
        })
        .catch(error => {
          self.$message(null, error.response ? error.response.data : 'Erro ao alocar', 'error')
        })
        .finally(() => {
          self.alocando = false
        })
    },

    abrirDevolucao(a) {
      this.devolvendoId = a.id
      this.devolucaoQtd = a.quantity
    },

    devolucaoValida(a) {
      const q = Number(this.devolucaoQtd)

      return q >= 1 && q <= a.quantity
    },

    confirmarDevolucao(a) {
      if (!this.devolucaoValida(a)) return

      const self = this
      self.devolvendo = true

      axios
        .post(`${self.$store.state.api}equipment/allocations/${a.id}/release`, {
          quantity: Number(self.devolucaoQtd),
        })
        .then(() => {
          self.devolvendoId = null
          self.carregarEquipamentos()
        })
        .catch(error => {
          self.$message(null, error.response ? error.response.data : 'Erro ao devolver', 'error')
        })
        .finally(() => {
          self.devolvendo = false
        })
    },

    dataHora(iso) {
      if (!iso) return '—'
      return new Date(iso).toLocaleString('pt-BR')
    },

    save() {
      const self = this
      let api = `${self.$store.state.api}teams`

      if (self.team.id) {
        self.team._method = 'PUT'
        api += `/${self.team.id}`
      }

      self.$loading(true)

      axios
        .post(api, self.team)
        .then(response => {
          self.$message(
            'Sucesso',
            'Informações guardadas com sucesso',
            'success',
          )
          self.$loading(false)
          this.$router.push('/teams')
        })

        .catch(error => {
          self.$loading(false)
          self.$message(null, error.response.data, 'error')
        })
    },
    getTeamTypes() {
      const self = this

      axios
        .get(`${self.$store.state.api}team_types?paginated=false&status=1`)
        .then(response => {
          self.teamTypes = response.data.data || []
        })
        .catch(() => {
          self.teamTypes = []
        })
    },
    getVehicles() {
      const self = this
      const api = `${self.$store.state.api}vehicles?paginated=false&status=1`

      axios
        .get(api)
        .then(response => {
          self.vehicles = response.data.data
        })
        .catch(error => {
          self.$message(null, error.response.data, 'error')
        })
    },
    getTeam(id) {
      const self = this
      const api = `${self.$store.state.api}teams/${id}`
      self.$loading(true)

      axios
        .get(api)
        .then(response => {
          self.team = response.data.data[0]
          self.carregarEquipamentos()
          self.$loading(false)
        })
        .catch(error => {
          self.$message(null, error.response.data, 'error')
        })
    },
  },
}
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>
